import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Link } from "react-router-dom";
import "./ExistingCase.css";

/* ----------------------------------------------------
   à°Å¸â€�Â¹ Company Card (ONE COMPANY)
---------------------------------------------------- */
const CompanyCard = React.memo(({ company }) => {
  const formatDate = (date) => {
    if (!date) return "Unknown date";
    return new Date(date).toLocaleDateString("en-US");
  };

  return (
    <div className="case-card">
      <h2>{company.company_name}</h2>

      <div className="case-details">
        <p><strong>Sector:</strong> {company.activity_sector || "Not specified"}</p>
        <p><strong>Size:</strong> {company.company_size || "Not specified"} employees</p>
        <p><strong>Added:</strong> {formatDate(company.date_added)}</p>
      </div>

      {/* à°Å¸â€�Â¥ Now this shows "View Company Cases" */}
      <Link
        to={`/company-cases/${company._id}`}
        className="view-case-btn"
      >
        View Company Cases
      </Link>
    </div>
  );
});

/* ----------------------------------------------------
    Search bar
---------------------------------------------------- */
const SearchBar = React.memo(({ onSearch }) => {
  return (
    <div className="search-bar">
      <input
        type="text"
        placeholder="Search a company..."
        onChange={(e) => onSearch(e.target.value)}
        className="search-input"
      />
      <span className="search-icon"></span>
    </div>
  );
});

/* ----------------------------------------------------
   à°Å¸â€�Å½ Filter by sector
---------------------------------------------------- */
const FilterBar = React.memo(({ sectors, onFilter }) => {
  const [active, setActive] = useState("all");

  const choose = (sector) => {
    setActive(sector);
    onFilter(sector);
  };

  return (
    <div className="filter-bar">
      <div className="filter-label">Filter by sector:</div>
      <div className="filter-options">
        <button
          className={`filter-btn ${active === "all" ? "active" : ""}`}
          onClick={() => choose("all")}
        >
          All
        </button>

        {sectors.map((sec, idx) => (
          <button
            key={idx}
            className={`filter-btn ${active === sec ? "active" : ""}`}
            onClick={() => choose(sec)}
          >
            {sec}
          </button>
        ))}
      </div>
    </div>
  );
});

/* ----------------------------------------------------
   à°Å¸â€�Â¢ Pagination
---------------------------------------------------- */
const Pagination = React.memo(({ total, perPage, current, onChange }) => {
  const totalPages = Math.ceil(total / perPage);
  if (totalPages <= 1) return null;

  const pages = [...Array(totalPages).keys()].map((n) => n + 1);

  return (
    <div className="pagination">
      {pages.map((page) => (
        <button
          key={page}
          className={`pagination-number ${page === current ? "active" : ""}`}
          onClick={() => onChange(page)}
        >
          {page}
        </button>
      ))}
    </div>
  );
});

/* ----------------------------------------------------
   à°Å¸â€�Â¥ MAIN PAGE : EXISTING COMPANIES
---------------------------------------------------- */
export default function ExistingCompanies() {
  const [companies, setCompanies] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true);

  const [search, setSearch] = useState("");
  const [filterSector, setFilterSector] = useState("all");
  const [page, setPage] = useState(1);

  const perPage = 6;

  /* -----------------------------------------
     1à¯Â¸Â�à¢Æ’Â£ Fetch all enterprises from MongoDB
  ----------------------------------------- */
  const fetchCompanies = useCallback(async () => {
    try {
      setLoading(true);

      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/enterprises`, {
        headers: { "ngrok-skip-browser-warning": "true" },
      });

      const data = await res.json();
      console.log("API enterprises à¢â€ â€™", data);

      // à°Å¸â€�Â¥ Universal safe extraction
      const list =
        Array.isArray(data)
          ? data
          : Array.isArray(data.enterprises)
          ? data.enterprises
          : Array.isArray(data.data)
          ? data.data
          : data.found && Array.isArray(data.items)
          ? data.items
          : [];

      setCompanies(list);
      setFiltered(list);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching enterprises:", err);
      setCompanies([]);
      setFiltered([]);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCompanies();
  }, [fetchCompanies]);

  /* -----------------------------------------
     2à¯Â¸Â�à¢Æ’Â£ Compute unique sectors
  ----------------------------------------- */
  const sectors = useMemo(() => {
    if (!Array.isArray(companies)) return [];
    return [...new Set(companies.map((c) => c.activity_sector))].filter(Boolean);
  }, [companies]);

  /* -----------------------------------------
     3à¯Â¸Â�à¢Æ’Â£ Apply search + filter
  ----------------------------------------- */
  useEffect(() => {
    let list = [...companies];

    if (filterSector !== "all") {
      list = list.filter((c) => c.activity_sector === filterSector);
    }

    if (search.trim()) {
      const s = search.toLowerCase();
      list = list.filter((c) =>
        c.company_name.toLowerCase().includes(s)
      );
    }

    setFiltered(list);
    setPage(1);
  }, [companies, search, filterSector]);

  /* -----------------------------------------
     4à¯Â¸Â�à¢Æ’Â£ Paginate
  ----------------------------------------- */
  const paginated = useMemo(() => {
    const start = (page - 1) * perPage;
    return filtered.slice(start, start + perPage);
  }, [filtered, page]);

  /* -----------------------------------------
     5à¯Â¸Â�à¢Æ’Â£ Render
  ----------------------------------------- */
  return (
    <div className="container-center-horizontal">
      <div className="existing-case-63 screen">
        <div className="main-content">

          {/* Header */}
          <div className="page-header">
            <h1 className="page-title">Existing Companies</h1>

            <div className="new-case-container">
              <Link to="/acquisition" className="create-new-btn">
                New Company
              </Link>
            </div>
          </div>

          {/* Search + Refresh */}
          <div className="controls-container">
            <SearchBar onSearch={setSearch} />
            <button className="refresh-btn" onClick={fetchCompanies}>
              Refresh
            </button>
          </div>

          {/* Filter */}
          {filtered.length > 0 && (
            <FilterBar sectors={sectors} onFilter={setFilterSector} />
          )}

          {/* List */}
          {loading ? (
            <div className="loading-message">Loading companies...</div>
          ) : filtered.length === 0 ? (
            <div className="no-results-message">
              <p>No companies match your criteria.</p>
              <button
                className="reset-filters-btn"
                onClick={() => {
                  setSearch("");
                  setFilterSector("all");
                }}
              >
                Reset filters
              </button>
            </div>
          ) : (
            <>
              <div className="cases-grid">
                {paginated.map((company) => (
                  <CompanyCard key={company._id} company={company} />
                ))}
              </div>

              {/* Pagination */}
              <Pagination
                total={filtered.length}
                perPage={perPage}
                current={page}
                onChange={setPage}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
